import { useQuery, type UseQueryResult } from "@tanstack/react-query"

import { UTILITY_KEYS } from "~/api/cache"

import type { UtilityOptionsResponseDto } from "../dto/proposal-utility.dto"
import { proposalUtilityService } from "../services/proposal-utility.service"

const FIVE_MINUTES_MS = 5 * 60 * 1000

export default function useFetchUtilityOptions(
  proposalId: string,
): UseQueryResult<UtilityOptionsResponseDto, unknown> {
  return useQuery({
    queryKey: UTILITY_KEYS.options(proposalId),
    queryFn: () => proposalUtilityService.getUtilityOptions(proposalId),
    enabled: !!proposalId,
    staleTime: FIVE_MINUTES_MS,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}
